import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import './frontend.css';

// ─── Init ────────────────────────────────────────────────────────────────────

document.addEventListener( 'load', () => {
    document.querySelectorAll( '.uc-slider-section' ).forEach( initSection );
} );

window.addEventListener( 'load', () => {
    document.querySelectorAll( '.uc-slider-section' ).forEach( section => {
        const slides = section.querySelectorAll( '.uc-slide' );
        initSection( section );
    } );
} );

function initSection( section ) {
    const isMobile = window.matchMedia( '(max-width: 768px)' );

    if ( isMobile.matches ) {
        initMobile( section );
    } else {
        initDesktop( section );
    }

    // On breakpoint crossing — reload to safely re-init
    let wasMobile = isMobile.matches;
    isMobile.addEventListener( 'change', ( e ) => {
        if ( e.matches !== wasMobile ) {
            wasMobile = e.matches;
            window.location.reload();
        }
    } );
}

// ─── DESKTOP: scroll-driven arc ──────────────────────────────────────────────

function initDesktop( section ) {
    const track  = section.querySelector( '.uc-slider-track' );
    const slides = [ ...track.querySelectorAll( ':scope > .uc-slide' ) ];
    if ( ! slides.length ) return;

    const n = slides.length;

    // Section height = n screen-heights so scroll covers all slides
    section.style.height = n * 60 + 'vh';

    // Arc parameters — tweak these to taste
    const ARC_DEG    = 10;   // degrees of arc per slide offset
    const RADIUS     = 4200; // px — virtual arc circle radius
    const ROT_STEP   = 9;   // card tilt per offset step (deg)
    const SCALE_STEP = 0.06; // scale reduction per step

    function getProgress() {
        const top         = section.getBoundingClientRect().top;
        const totalScroll = section.offsetHeight - window.innerHeight;
        return Math.max( 0, Math.min( 1, -top / totalScroll ) );
    }

    function render() {
        const activeFloat = getProgress() * ( n - 1 );

        slides.forEach( ( slide, i ) => {
            const offset   = i - activeFloat;
            const angleRad = ( offset * ARC_DEG * Math.PI ) / 180;

            const tx     = Math.sin( angleRad ) * RADIUS;
            const ty     = RADIUS - Math.cos( angleRad ) * RADIUS;
            const rotate = offset * ROT_STEP;
            const scale  = Math.max( 0.75, 1 - Math.abs( offset ) * SCALE_STEP );

            const opacity = 1;
            const zIndex  = Math.round( 100 - Math.abs( offset ) * 10 );

            slide.style.transform =
                `translate( calc( -50% + ${ tx }px ), calc( -50% + ${ ty }px ) ) ` +
                `rotate( ${ rotate }deg ) ` +
                `scale( ${ scale } )`;
            slide.style.opacity       = opacity;
            slide.style.zIndex        = zIndex;
            slide.style.pointerEvents = Math.abs( offset ) < 0.55 ? 'auto' : 'none';
        } );
    }

    window.addEventListener( 'scroll', render, { passive: true } );
    render(); // paint initial state
}

// ─── MOBILE: Swiper ──────────────────────────────────────────────────────────

function initMobile( section ) {
    const track        = section.querySelector( '.uc-slider-track' );
    const paginationEl = section.querySelector( '.uc-slider-pagination' );
    const slides       = [ ...track.querySelectorAll( ':scope > .uc-slide' ) ];
    if ( ! slides.length ) return;

    // Switch section to natural flow
    section.style.height = '';
    section.classList.add( 'uc-slider--mobile' );

    // Build Swiper DOM inside .uc-slider-track
    const swiperWrapper = document.createElement( 'div' );
    swiperWrapper.className = 'swiper-wrapper';

    slides.forEach( ( slide ) => {
        track.removeChild( slide );

        // Reset any leftover inline styles from desktop
        slide.style.cssText = '';

        const swiperSlide = document.createElement( 'div' );
        swiperSlide.className = 'swiper-slide';
        swiperSlide.appendChild( slide );
        swiperWrapper.appendChild( swiperSlide );
    } );

    track.appendChild( swiperWrapper );
    track.classList.add( 'swiper' ); // track becomes the Swiper root

    if ( paginationEl ) {
        paginationEl.classList.add( 'swiper-pagination' );
        track.appendChild( paginationEl );
    }

    new Swiper( track, {
        modules: [ Pagination ],
        slidesPerView: 1.15,
        spaceBetween: 16,
        centeredSlides: true,
        grabCursor: true,
        pagination: paginationEl
            ? { el: paginationEl, clickable: true }
            : false,
    } );
}
